// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3u9Nd","ranges":"BmiRanges_ranges__2x4sp"};